import { FormProperty } from './formProperty';
import { PropertyTypes } from '../enum/propertyTypes';
import { EventEmitter } from '@angular/core';
import { GsLocationMultiselectWithExpirationComponent } from '../../controls/gs.location-multiselect-expiration/gs.location-multiselect-expiration.component';

export class FormLocationMultiselectWithExpirationProperty extends FormProperty {
  get options() {
    return this._options;
  }
  set options(value) {
    this._options = value;
    this.optionsSet.next();
  }
  get companyGroupID() {
    return this._companyGroupID;
  }
  set companyGroupID(value) {
    this._companyGroupID = value;
    this.companyGroupIDSet.next();
  }
  private _options?: any[];
  private _companyGroupID: number;
  source: any;
  type = PropertyTypes.LocationMultiselect;
  component = GsLocationMultiselectWithExpirationComponent;
  changed = new EventEmitter<any>();
  optionsSet = new EventEmitter<void>();
  companyGroupIDSet = new EventEmitter<void>();
  selectedValue: any;
  defaultLabel = 'Choose';

  constructor(
    name: string,
    label: string,
    options?: [],
    row?: number,
    column?: number,
    rowspan?: number,
    columnspan?: number,
    validate?: boolean
  ) {
    super(name, label, row, column, rowspan, columnspan, validate);
    this.options = options ? options : this.options;
  }
}
